import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { BaseModalPageComponent } from '../../../base-modal.component';
import { ModalComponent } from '../../../modal/modal.component';

@Component({
    selector: 'contacts-picker-modal',
    templateUrl: 'contactsPickerModal.component.html',
    standalone: false
})
export class ContactsModalComponent extends BaseModalPageComponent {
  contacts: any[] = [];

  constructor(public selfModal: ModalComponent, location: Location) {
    super(location);
  }

  public init(data: any) {
    this.contacts = data;
  }

  public selectItem(contacts) {
    contacts.selected = !contacts.selected;
  }

  apply() {
    this.selfModal.close(this.contacts.filter((x) => x.selected));
  }

  reset() {
    this.selfModal.close([]);
  }
}
